import {
    ConfigurableRoutesService,
    ProtectedRoutesService,
    RoutingConfig,
    RoutingConfigService,
    UrlMatcherService,
} from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { SikoProtectedRoutesService } from './siko-protected-routes.service';

@Injectable({
    providedIn: 'root',
})
export class SikoConfigurableRoutesService extends ConfigurableRoutesService {
    constructor(
        protected injector: Injector,
        protected routingConfigService: RoutingConfigService,
        protected urlMatcherService: UrlMatcherService,
        protected config: RoutingConfig,
        protected http: HttpClient,
        protected protectedRoutesService: ProtectedRoutesService,
    ) {
        super(injector, routingConfigService, urlMatcherService);
    }

    initOverrideRoutes(): void {
        this.addRoutingConfig('cxpreview', ['cx-preview'], false);
    }

    private addRoutingConfig(key: string, urls: string[], isProtected: boolean): void {
        const routeConfig = this.config.routing?.routes;

        if (this.config.routing && this.protectedRoutesService instanceof SikoProtectedRoutesService) {
            this.config.routing.routes = {
                ...routeConfig,
                ...{
                    [key]: {
                        paths: urls,
                        protected: isProtected,
                    },
                },
            };

            this.configure();
            this.protectedRoutesService.reloadProtectedRoutes();
        }
    }
}
